import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { useRootStore } from '../../../../../root/RootStoreHooks';

export const Braintree3ds = observer(() => {
  const rootStore = useRootStore();
  const { billingEntry, threeDSecureEntry: { braintree3ds } = {} } = rootStore.moduleStores;
  const { isLastStep } = rootStore.stepsManager;
  const { hasUserInput } = billingEntry?.creditCardData ?? {};
  useEffect(() => {
    if (braintree3ds?.isEnabled) {
      if (isLastStep || hasUserInput) {
        braintree3ds.initAuth();
      }
    }
  }, [braintree3ds, braintree3ds?.isEnabled, hasUserInput, isLastStep]);

  return null;
});
